import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";

const Cart = () => {
  const [items, setItems] = useState([]);

  // ✅ Load cart data
 useEffect(() => {
  let data = JSON.parse(localStorage.getItem("cart"));

  // ✅ If single object → convert to array
  if (data && !Array.isArray(data)) {
    data = [data];
  }

  setItems(data || []);
}, []);


  // ✅ DELETE SINGLE ITEM
  const handleDelete = (index) => {
    const updatedCart = items.filter((_, i) => i !== index);

    setItems(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  return (
    <>
      {/* <Header /> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />

      <section className="cart-details-section">
        {items.length === 0 ? (
          <h3 style={{ textAlign: "center" }}>Cart is Empty</h3>
        ) : (
          <>
            <div className="cart-item-card">
              {/* Header */}
              <div className="cart-item-header">
                <div className="cart-header-cell col-product">Product</div>
                <div className="cart-header-cell col-medium">Date</div>
                <div className="cart-header-cell col-medium">Time</div>
                <div className="cart-header-cell col-medium">Location</div>
                <div className="cart-header-cell col-medium">Price</div>
                <div className="cart-header-cell col-actions">Actions</div>
              </div>

              {/* Body */}
              {items.map((item, index) => (
                <div className="cart-item-body" key={index}>
                  {/* Product */}
                  <div
                    className="cart-body-cell col-product"
                    style={{ flexDirection: "column", alignItems: "start" }}
                  >
                    <img
                      src={item.image || "assets/img/deals1.jpg"}
                      alt="Yacht"
                      className="cart-product-image"
                    />
                    <span className="cart-product-name">
                      {item.boatName}
                    </span>
                  </div>

                  {/* Date */}
                  <div className="cart-body-cell col-medium">
                    {item.date}
                  </div>

                  {/* Time */}
                  <div className="cart-body-cell col-medium">
                    {item.time}
                  </div>

                  {/* Location */}
                  <div className="cart-body-cell col-medium">
                    {item.location}
                  </div>

                  {/* Price */}
                  <div className="cart-body-cell col-medium">
                    ₹ {item.price}
                  </div>

                  {/* Delete */}
                  <div className="cart-body-cell col-actions">
                    <button
                      className="cart-action-button delete-icon"
                      onClick={() => handleDelete(index)}
                    >
                      <i className="fas fa-trash-alt" />
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* ✅ Total Price */}
            

            {/* Confirm Booking */}
            <div className="confirm-booking-container">
              <a href="/addons" className="confirm-booking-button">
                Confirm Booking
              </a>
            </div>
          </>
        )}
      </section>

      <Footer />
    </>
  );
};

export default Cart;
